"use client";
import { useTranslations } from 'next-intl';
import Projects from './Projects';
import Years from './Years';
import { useState } from 'react';

const CURRENT_YEAR = Number(new Date().getFullYear());

export default function ProductsHero() {
  const t = useTranslations('Home');
  const [year, setYear] = useState<number>(CURRENT_YEAR)

  return (
    <section className="grid grid-cols-1 md:grid-cols-12 w-full ps-0 md:ps-0">
      <div className="md:col-span-1  z-50 sticky top-0 md:h-screen overflow-y-auto border-r-1 border-b-1 border-slate-100 pt-0 ps-4 md:ps-0 md:pt-22 text-center">
        <Years year={year} setYear={setYear}/>
      </div>
      <div className="col-span-10 grid grid-cols-12 h-fit">
        <div className="col-span-12 md:col-span-6 border-r-1 border-b-1 border-slate-100 h-full py-4 md:py-12 ps-8">
          <h3 className='text-base md:text-xl font-semibold color-primary'>{t('your_first_choice_since')}</h3>
        </div>
        <div className="col-span-3 hidden md:block border-b-1 border-slate-100"></div>
        <div className="col-span-3 hidden md:block border-l-1 border-b-1 border-slate-100"></div>
        <div className="col-span-12 border-slate-100">
          <Projects year={year} setYear={setYear}/>
        </div>
      </div>
      <div className="col-span-1 border-l-1 border-b-1 border-slate-100"></div>
    </section>
  );
}
